var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobileClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.914,
    height: 16.414
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 35069"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Search Icon",
    fill: "none",
    stroke: "#11385a",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 64",
    d: "M.707.707l14.5 15"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 170",
    d: "M15.207.707l-14.5 15"
  })))));
}

export default SvgMobileClose;